// Orden de categorías: Sub-X ascendente, luego categorías especiales desconocidas (alfabético)
// y al final Tercera, Reserva, Primera. Debe coincidir con sort_category_key del backend.
const SPECIAL_CATEGORY_ORDER = ['tercera', 'reserva', 'primera'];

export const categorySortKey = (cat) => {
  const name = (cat?.name || '').trim();
  const sub = name.match(/sub-?\s*(\d+)/i);
  if (sub) return [0, parseInt(sub[1], 10), name.toLowerCase()];
  const lowered = name.toLowerCase();
  const rank = SPECIAL_CATEGORY_ORDER.findIndex((s) => lowered === s || lowered.startsWith(`${s} `));
  if (rank >= 0) return [2, rank, lowered];
  return [1, 0, lowered];
};

export const sortCategories = (cats) =>
  [...(cats || [])].sort((a, b) => {
    const ka = categorySortKey(a);
    const kb = categorySortKey(b);
    if (ka[0] !== kb[0]) return ka[0] - kb[0];
    if (ka[1] !== kb[1]) return ka[1] - kb[1];
    return ka[2].localeCompare(kb[2]);
  });
